<template>
  <!-- Start Main Content -->
  <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
      <div class="card  ">
            <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row  ">
          <h2 class="card-title">Account List</h2>
           <button class="btn b-light btn-success-light" @click="AddModal(item)"> <i class="ri-add-line text-success text-[13px]"></i> 
            Voucher Entry
          </button>
          </div>
      </div>
      <div class="grid grid-cols-12 gap-4 mb-6 items-end">
        <div class="col-span-4">
            <label for="from_date" class="form-label">From Date</label>
            <input type="date" v-model="fromDate" class="form-input" id="from_date">
        </div>
        <div class="col-span-4">
            <label for="to_date" class="form-label">To Date</label>
            <input type="date" v-model="toDate" class="form-input" id="to_date">
        </div>
        <div class="col-span-4 flex items-end">
            <!-- Empty label for spacing alignment -->
            <!-- <label class="form-label invisible">Filter</label> -->
            <button @click="filterByDate" class="btn b-solid btn-primary-solid">Filter</button>
        </div>
    </div>
      <div class="grid grid-cols-12">
          <!-- INITIALIZE CSS CLASS -->
          <div class="hidden">
              <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
              <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
              <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
              <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
              <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
          </div>
          <!-- INITIALIZE CSS CLASS -->
          <div class="tablejs sr-only size-0"></div>
          <!-- BASIC DATA TABLE -->
          <div class="col-span-full">
              <div class="card p-0">
                  <div class="p-6 space-y-4">
                      <table id="basicDataTable" ref="datatable" class="datatable">
                          <thead>
                              <tr>
                                  <th class="bg-[#B2E8D9]">Tr. Id</th>
                                  <th class="bg-[#B2E8D9]">Date</th>
                                  <th class="bg-[#B2E8D9]">Service Name</th>
                                  <!-- <th class="bg-[#B2E8D9]">Staff Name</th> -->
                                  <th class="bg-[#B2E8D9]">Member Name</th>
                                  <th class="bg-[#B2E8D9]">Total</th>   
                                  <th class="bg-[#B2E8D9]">Paid</th>
                                  <th class="bg-[#B2E8D9]">Balance</th>
                                  <th class="bg-[#B2E8D9]">Payment Type</th>
                                  <th class="bg-[#B2E8D9]">Note</th>
                                  <th class="px-3.5 py-4">Action</th>
                          
                              </tr>
                          </thead>
                          <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                               <!-- <tr v-for="(item ,index)  in filteredList" :key="item.id">
                                  <td>{{item.id}}</td>
                                   <td>{{item.iddate}}</td>
                                   <td>{{item.service_display_name}}</td> 
                                  <td>
                                    <a class="text-dark" @click.prevent="fetchRecordsByMemberName(item.firstname)">
                                      {{ item.member_name }}
                                    </a>                                    
                                  </td>                                 
                                  <td>{{item.total}}</td>
                                  <td>{{item.paid}}</td>
                                  <td>{{item.balance}}</td>
                                  <td>{{item.paymenttype}}</td>
                                  <td>{{item.note}}</td>
                                 

                                
                                  <td class="px-3.5 py-4">
                                      <div class="flex items-center gap-1">

                                         <button class="btn-icon btn-success-icon-light size-7" @click="editModal(item)">
                                              <i class="ri-add-line text-inherit text-[13px]"></i> 
                                          </button>  
                                         
                                          <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" >
                                              <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                          </button>
         


                                      </div>
                                  </td>



                          
                              </tr>  -->
                          </tbody>
                      </table>
                  </div>
                  <!-- Prism Code -->
                  <div class="p-6 hidden">
                      <pre>
                          <code class="language-markup">
                              &lt;p>Sorry we can't show the huge data table&lt;/p>
                          </code>
                      </pre>
                  </div>
                  <!-- Prism Code -->
              </div>
          </div>
          <!-- BORDERED SELECTION DELETION DATA TABLE -->
          
      </div>
  </div>
  <!-- End Main Content -->


  <!-- start add follow up model -->


  <div id="AddModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="background: #00000052;">
    <div class="p-4 w-full max-w-lg max-h-full">
      
      <div class="relative p-3 bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square max-h-full overflow-y-auto">
        <!-- <div class="mb-4 flex justify-center">
          <label class="mr-4">
            <input type="radio" :value="true" v-model="isCustomer" /> Member List
          </label>
          <label>
            <input type="radio" :value="false" v-model="isCustomer" /> Staff List
          </label>
        </div> -->
        <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
          <i class="ri-close-line text-inherit text-xl leading-none"></i>
        </button>
        <div class="p-4 md:p-5">
  
          <div class="col-span-full  lg:col-span-4 leading-none mt-8"v-show="isCustomer">
            <!-- <label class="form-label">Member Name *</label> -->
            <select class="form-input w-full" v-model="add.member_name" ref="memberSelect" style="width: 100%;">
                <option DISABLED value="0">Member Name</option>

                <!-- <option value="male">Male</option>
                <option value="female">Female</option> -->

                 <option v-for="(item, index)  in memberList" :value="item.id">{{ item.member_name }}</option> 
                 
            </select>
        </div> 


        
        <div class="col-span-full  lg:col-span-4 leading-none" v-show="!isCustomer">
          <!-- <label class="form-label">Member Name *</label> -->
          <select class="form-input w-full" v-model="add.staff_name" ref="staffSelect" style="width: 100%;">
              <option DISABLED value="0">Staff Name</option>

              <!-- <option value="male">Male</option>
              <option value="female">Female</option> -->

               <option v-for="(item, index)  in staffList" :value="item.id">{{ item.firstname }}</option> 
               
          </select>
      </div> 


          <div class="mt-7">
            <label for="contact" class="form-label">Paid Amount *</label>
            <input type="number" v-model="add.paid" class="form-input" id="contact" placeholder="Amount" autocomplete="off" required>
          </div>
  
          <div class="mt-7">
            <label for="start_date" class="form-label">Date *</label>
            <input type="date" v-model="add.startdate" class="form-input" id="start_date" :max="maxDate" :value="today" autocomplete="off" required>
          </div>
  
          <div class="mt-7">
            <label for="remark" class="form-label">Note *</label>
            <input type="text" v-model="add.note" class="form-input" id="remark" placeholder="Note" autocomplete="off" required>
          </div>
  
          <div class="flex justify-end mt-7">
            <button @click="save_addmodel" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
    
    
   <!-- end add follow up model -->







  
<!-- Start Edit Modal -->
<div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="background: #00000052;">
  <div class="p-4 w-full max-w-lg max-h-full">
    <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square max-h-full overflow-y-auto ">
        <h3 class="p-4 w-full max-w-lg max-h-full">Add Payment Voucher</h3>
      <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
        <i class="ri-close-line text-inherit text-xl leading-none"></i>
      </button>
      <div class="p-4 md:p-5">
        

  



        <div class="mt-7">
          <label for="tagname" class="form-label">Entry Date *</label>
          <input type="date" v-model="account.startdate" class="form-input" autocomplete="off" required>
        </div>

        <div class="mt-7">
          <label for="tagname" class="form-label">Amount *</label>
          <input type="number" v-model="account.paid" class="form-input"   placeholder="Amount" autocomplete="off" required>
        </div>


        <div class="mt-7">
          <label class="form-label">Payment type *</label>
          <select class="form-input" v-model="account.paymenttype">
              <option DISABLED value="0">SELECT PAYMENT TYPE</option>

              <option value="Cash">Cash</option>
              <option value="Upi">Upi</option>
              <option value="Card">Card</option>

              <!-- <option v-for="(item, index)  in packageList" :value="item.id">{{ item.name }}</option> -->
               
          </select>

      </div> 

        <div class="mt-7">
          <label for="tagname" class="form-label">Note *</label>
          <input type="text" v-model="account.note" class="form-input" id="first_input" placeholder="Remark" autocomplete="off" required>
        </div>

        <div class="flex justify-end mt-7">
          <button @click="save_updateaccount" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Edit Modal -->











  
     <!-- Start Delete Modal -->
  <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
      <div class="p-4 w-full max-w-md max-h-full">
          <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
              <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                  <i class="ri-close-line text-inherit text-xl leading-none"></i>
              </button>
              <div class="p-4 md:p-5 text-center">
                  <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                  <div class="mt-5 text-center">
                      <h5 class="mb-1">Are you sure?</h5>
                      <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                      <div class="flex justify-center gap-2 mt-6">
                          <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                          <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- End Delete Modal -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';


export default {
name: 'AddProduct',
components: {

} ,
mounted(){
this.getBasics();
// Get today's date
const date = new Date();
    this.today = date.toISOString().split('T')[0];  // Format: YYYY-MM-DD
    this.maxDate = this.today;  // Set max date to today
    this.add.startdate = this.today;  // Set default date to today
// this.memberId = this.$route.params.id;
// console.log("Member ID from route:", this.memberId);
// this.loadAccountList();
$(this.$refs.memberSelect).select2({
      placeholder: "Member Name",
      allowClear: true,
    }).on("change", (e) => {
      this.add.member_name = $(e.target).val();
    });

    $(this.$refs.staffSelect).select2({
      placeholder: "Staff Name",
      allowClear: true,
    }).on("change", (e) => {
      this.add.staff_name = $(e.target).val();
    });


},
beforeDestroy() {
    $(this.$refs.memberSelect).select2('destroy'); // Clean up
  },
  beforeDestroy() {
    $(this.$refs.staffSelect).select2('destroy'); // Clean up
  },

data() {
  const today = new Date().toISOString().split('T')[0];
return {
  isCustomer:true,
   isAdd:0,
   isEdit:0,
   isDelete: 0,
   deleteId: 0,
   productsList:[],
   accountshow:[],
   leadlists:[],
   accountlists:[],
   userRole:localStorage.getItem('userRole'),
   datatable:null,
   followup_list:[],
   accountList: [],
   staffList:[],
   memberId: null ,
   fromDate:today,
   toDate:today,
   filteredList: [],
   memberList:[],
  //  accountlist:[],
   accountlist:{
    id:'',
    total:'',
    paid:'',
    paymenttype:'',
   },


   add:{
    member_name:'',
    staff_name:'',
    paid:'',
    startdate:'',
    note:'',
   },

   today: '',  
   maxDate: '',  
   secondadd:{
    firstname:'',
    lastname:'',
   },


  account:{
      staffid:'',
      memberid:'',
      startdate:today,
      paid:'',
      note:'',
      paymenttype:'',
    

  },
  memberData: [],
  members:[],

}
},  
computed: {
    // Get memberid from query parameters
    memberid() {
      return this.$route.query.memberid;
    }
  },
  watch: {
    // Watch for changes in the query parameters
    '$route.query.memberid': 'fetchMemberDetails'
  },
  created() {
    // Fetch member details when component is created
    this.fetchMemberDetails();
  },
methods:{ 
  getOnlyDate(date){
    
    try {
    if(date){
      var dateHere=date;
      return dateHere.split(' ')[0];
    }else
    return '';
      
    } catch (error) {
      alert(error);
    return '';
    }
    
  },
  // Method to fetch records for the selected member
  async fetchRecordsByMemberName(memberName) {
    try {
      const response = await axios.get(`getRecordsByMemberName/${memberName}`);
      this.accountList = response.data.memberlist; // Assuming the response structure
      console.log(this.accountList); // For debugging
    } catch (error) {
      console.error("Error fetching records:", error);
    }
  },
  AddModal() {
      // Show the modal
      if(!this.isAdd)
       $("#AddModal").removeClass('hidden');
   else
       $("#AddModal").addClass('hidden');
   this.isAdd=!this.isAdd;
    },



closeModal(){
  $("#editModal").addClass('hidden');
          $("#deleteModal").addClass('hidden');
      this.isAdd=0;
      this.isEdit=0;
      this.isDelete=0;
      this.deleteId=0;


      $("#AddModal").addClass('hidden');
          $("#AddModal").addClass('hidden');
      this.isAdd=0;
      this.isEdit=0;
      this.isDelete=0;
      this.deleteId=0;
      
},
addModal(){
   this.cat={name:'',status:'Active'};
   if(!this.isAdd)
       $("#editModal").removeClass('hidden');
   else
       $("#editModal").addClass('hidden');
   this.isAdd=!this.isAdd;
},

editModal(memberid){
   if(memberid){
       this.account.memberid=memberid;
       console.log(this.account.memberid);
//       axios.post('updateaccountrecord',{memberid:item.memberid}).then(function (response) {
//                 self.accountlists=response.data.account;
//                 //console.log(self.leadlists);
//               }).then(()=>{ 
              
//                   });;
 
    }
   if(!this.isEdit)
       $("#editModal").removeClass('hidden');
   else
       $("#editModal").addClass('hidden');
   this.isEdit=!this.isEdit;
},



 
       save_updateaccount() {
           var self = this; 
           axios.post('updateaccountrecord', this.account)
               .then(response => {
                   var msg = response.data.msg;
                   var isSuccess = response.data.status;
                   self.accountList=response.data.accountlist;
                    
                   self.getBasics();
                   self.closeModal();
               }).then(()=>{ 
                   self.datatable.destroy();
                  self.datatable= $(".datatable").DataTable({
                          "paging": true,
                          "ordering": true,  
                          "autoWidth": false });
            
                  }).catch(error => {
                   console.log('Error on Authentication: ' + error);
               });
       },



       save_addmodel(){

        var self = this; 
        
          if(self.add.member_name=='')
            self.$swal("Select Member Name is Required");
        else if(self.add.paid=='')
            self.$swal("Paid Amount is Required");
        else{
           axios.post('addaccountrecord', {add:JSON.stringify(this.add)})
               .then(response => {
                   var msg = response.data.msg;
                   var isSuccess = response.data.status;
                   self.getBasics();
                   self.closeModal();
               })
               .catch(error => {
                   console.log('Error on Authentication: ' + error);
               });

        }
},

deleteModal(id){
  this.deleteId=id;
   if(!this.isDelete)
       $("#deleteModal").removeClass('hidden');
   else
       $("#deleteModal").addClass('hidden');
   this.isDelete=!this.isDelete;
},
async getBasics() {
     var self=this;
       axios.post('getaccountlist').then(function (response) {
                self.accountList=response.data.accountlist;
                self.memberList=response.data.memberlist;
                self.filteredList = self.accountList;
                self.staffList=response.data.stafflist;
                self.employees=response.data.userDetails;
                self.initDataTable(self.filteredList);
                self.members = self.fetchMemberDetails(self.accountList)
              }).then(()=>{ 
                  // self.datatable= $(".datatable").DataTable({
                  //         "paging": true,
                  //         "ordering": true,  
                  //         "autoWidth": false });
            
                  });
}, 
fetchMemberDetails(List) {
      const memberid = this.memberid;
      this.accountList = List;
      
      if (memberid && this.accountList) {
        
        this.filteredList = this.accountList.filter(member => member.memberid == memberid);
        this.initDataTable(this.filteredList);
      }
    },
initDataTable(data) {
  var self=this;
            if ($.fn.dataTable.isDataTable(this.$refs.datatable)) {
                $(this.$refs.datatable).DataTable().clear().destroy();
            }

            // Reinitialize the DataTable with the new data
            this.datatable = $(this.$refs.datatable).DataTable({
                data: data,
                columns: [
                    { data: 'id' },
                    { data: (row) => this.getOnlyDate(row.iddate) },
                    { data: 'service_display_name' },
                    // { data: 'staff_name' },
                    // { data: 'member_name' },
                    {
                      data: 'member_name',
                      render: function(data, type, row) {
                          return `<span class="clickable-cell" data-type="member_name" data-value="${data}" data-id="${row.id}">${data}</span>`;
                      }
                    },
                    { data: 'total' },
                    { data: 'paid' },
                    { data: 'balance' },
                    { data: 'paymenttype' },
                    { data: 'note' },
                    {
                        data: null,
                        render: (data,userRole,row) => {
                            return `
                                <div class="flex items-center gap-1">
                                    <button class="btn-icon btn-success-icon-light size-7 edit-btn" data-id="${row.memberid}">
                                        <i class="ri-add-line text-inherit text-[13px]"></i>
                                    </button>  
                                    ${userRole === '1' ? `
        <button class="btn-icon btn-danger-icon-light size-7 delete-btn" data-id="${data.id}">
          <i class="ri-delete-bin-line text-danger text-[13px]"></i>
        </button>
      ` : ''}
    </div>
                            `;
                        },
                        orderable: false,
                        searchable: false
                    }
                ],
                paging: true,
                ordering: true,
                autoWidth: false,
                order: [[0, 'desc']],
                dom: 'Bfrtip', 
                            buttons: [
                              {
                                extend: 'excelHtml5',
                                title: 'Excel',
                              },
                            ],  
            });

            // Attach event listeners to dynamically created buttons
            $(this.$refs.datatable).off('click', '.edit-btn').on('click', '.edit-btn', function(event) {
            const id = $(event.currentTarget).data('id');
              self.editModal(id);  // Pass the ID to editModal
          });

          $(this.$refs.datatable).off('click', '.delete-btn').on('click', '.delete-btn', function(event) {
              const id = $(event.currentTarget).data('id');
              self.deleteModal(id);  // Pass the ID to deleteModal
          });

            $('.datatable').on('click', '.clickable-cell', function() {
                const field = $(this).data('type');
                const value = $(this).data('value');
                self.filter_user(field, value);
            });
        },
        filter_user(field, value) {
    this.filteredList = this.accountList.filter(item => item[field] === value);
    this.initDataTable(this.filteredList); // Update DataTable with filtered data
},

delete_category() {
              var self = this; 
              axios.post('deleteaccountinglist', {deleteId:this.deleteId})
                  .then(response => {
                      self.accountList=response.data.accountlist;
                      self.employees=response.data.userDetails; 
                       self.closeModal(); 
                  })
                  .catch(error => {
                      console.log('Error on Authentication: ' + error);
                  });
          },
          filterByDate() {
            if (this.fromDate && this.toDate) {
                this.filteredList = this.accountList.filter(item => {
                    return item.iddate >= this.fromDate && item.iddate <= this.toDate;
                });
            } else {
                this.filteredList = this.accountList;
            }
            // if ($.fn.dataTable.isDataTable(self.datatable)) {
            //   self.datatable.DataTable().clear().destroy();
            // }
            // self.datatable= $(".datatable").DataTable({
            //               "paging": true,
            //               "ordering": true,  
            //               "autoWidth": false });
            this.initDataTable(this.filteredList);
        },
}
}
</script>
